import type { PermissionMode, PermissionName } from '@heidi/agents/contracts';

export const PERMISSIONS_BY_MODE: Readonly<
  Record<PermissionMode, readonly PermissionName[]>
> = {
  recording: ['screen_recording', 'input_monitoring'],
  computer_use: ['screen_recording', 'accessibility'],
};

export const requiredPermissions = (mode: PermissionMode): readonly PermissionName[] =>
  PERMISSIONS_BY_MODE[mode];
